<template>
    <div class="table_wrap">
        <div class="filter_wrap">
            <div class="filter_row">
                <div class="filter_content language_filter">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">언어</span>
                    </div>
                    <el-select v-model="langOption" class="select faq_select mr5" @change="setFilterFunc('cid', langOption)">
                        <el-option :value="''" :label="'모두'"></el-option>
                        <el-option v-for="language in languageList" :key="`language${language.c_idx}`"
                                   :value="language.c_idx"
                                   :label="language.c_lang_ko"></el-option>
                    </el-select>
                </div>
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">작성일</span>
                    </div>
                    <div class="filter">
                        <el-date-picker
                            class="datePicker_long"
                            value-format="yyyy-MM-dd"
                            v-model="filterDate"
                            type="daterange"
                            start-placeholder="시작일"
                            end-placeholder="종료일"
                            @change="setFilterFunc('cr', filterDate)"
                            :default-time="['00:00:00', '23:59:59']">
                            :editable="false"
                        </el-date-picker>
                    </div>
                </div>
                <div class="filter_content ">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">카테고리</span>
                    </div>
                    <el-select v-model="filterCategory" class="select faq_select mr5" @change="setFilterFunc('ca', filterCategory)">
                        <el-option :value="''" :label="'전체'"></el-option>
                        <el-option v-for="category in categoryList" :key="`category${category.bc_idx}`"
                                   :value="category.bc_idx"
                                   :label="category.bc_name"></el-option>
                    </el-select>
                    <div class="filter">
                        <el-input v-model="searchInput" placeholder="검색어를 입력해 주세요." class="shortest mr10"
                                  @keypress.enter.native="setFilterFunc(searchInputOption, searchInput)"
                        >
                        </el-input>
                        <el-button class="com_search" @click="searchFilter(searchInputOption,searchInput)">
                            검색
                        </el-button>
                    </div>
                </div>
            </div>


        </div>
        <div class="filter-show-count mt15 mb15">
            <el-select class="veryShort" v-model="size" @change="changePage('size', size)">
                <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                           :label="`${sizeData}개씩 보기`"></el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import {mapState} from "vuex";
import {appLanguage} from "@/service/languageService"

const {filterConfig} = boardFilterUtil
export default {
    name: "BoardFilterFaqLayout",
    mixins: [boardFilterUtil],
    components: {},
    provide() {
        return {}
    },
    inject: ['setPage', 'setFilter'],
    props: {
        filterData: {
            default: () => {
                return {}
            }
        },
        paginationData: {
            type: Object,
            default: {
                total: 0,
                page: 0,
                size: 0,
            }
        },
    },
    data() {
        return {
            langOption: '',
            filterCategory: '',
            searchInputOption: 'su',
            searchInput: '',
            filterDate: '',
            size: 10,
            sizeList: [10, 30, 50],
            categoryList: [],
            languageList: appLanguage,
        }
    },
    created() {
        this.getCategory();
        // this.getLanguage();
    },
    mounted() {
        this.setterFilterDataInData();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    }

                }
            })
            this.size = this.paginationData.size;
        },
        getCategory() {
            let params = {
                ip: 0,
            }
            this.$api.$board.getCategory(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.categoryList = res.List;
            })
        },
        categorySetType(data) {
            if (data.bc_type === 1) {
                return `[일반]${data.bc_name}`;
            } else if (data.bc_type === 2) {
                return `[기관]${data.bc_name}`;
            }
        },
        // getLanguage(){
        //   let params = {
        //     id: 5
        //   }
        //   this.$api.$board.getLanguage(params).then(res => res.Data.Result).then(res => {
        //     if (res.Info.type != 1 || res.List.length === 0) {
        //       this.createAlert({
        //         title: '',
        //         content: '데이터를 불러올 수 없습니다.',
        //         btnText: '확인',
        //         hide: () => {
        //           this.$router.back();
        //         }
        //       });
        //       return;
        //     }
        //     this.languageList = res.List;
        //     console.log(this.languageList);
        //   })
        // },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },

        checkFilterData() {
            return this.filterDate != null && this.filterDate.length > 0;
        },

        changePage(key, value) {
            this.setPage(key, value);
            this.setPage('page', 1);
        },

        searchFilter(searchInputOption, searchInput) {
            if (searchInputOption === 'su') {
                this.setFilterFunc('ca', '')
                this.setFilterFunc(searchInputOption, searchInput)
            } else {
                this.setFilterFunc('su', searchInput);
                this.setFilterFunc('ca', searchInputOption)
            }
        },


    },
    watch: {},
}
</script>

<style scoped>

</style>
